/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {AccordionItem} from "./accordion-item";

export class Accordion {
  public title: string;
    public list: AccordionItem[];

  constructor(title: string) {
    this.title = title;
    this.list = [];
  }
  public addAccordionItem(icon: string, label: string, content: string) {
    this.list.push(new AccordionItem(icon, label, content));
  }
}
